import { forwardRef, useImperativeHandle, useRef } from 'react';
import {
  MenuItem,
  TextField,
} from '@mui/material';
import './PlayerSetup.scss';
import { playerPieceItems } from '../../../../../../components/vizzle/page/game/setup/PlayerPieceData';
import { filterUndefined } from '../../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  name: '',
  selectedPiece: 0,
  onDataChange: () => { },
  excludePieces: [],
};

const PlayerSetup = forwardRef((props, ref) => {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const nameRef = useRef(null);
  const pieceSelectorRef = useRef(null);

  const {
    name,
    selectedPiece,
    onDataChange,
    excludePieces,
  } = mergedProps;

  useImperativeHandle(ref, () => ({
    getEnableElements: () => [nameRef.current, pieceSelectorRef.current],
  }));

  const handleOnChange = (prop, value) => {
    onDataChange(prop, value);
  };

  return (
    <div className='game-player-setup'>
      <TextField
        label='Name'
        value={name}
        className='name-input'
        onChange={(e) => handleOnChange('name', e.target.value)}
        data-test='name-input'
        ref={nameRef}
        data-access-auto-focus='true'
      />
      &nbsp;
      <TextField
        select
        label='Select Piece'
        ref={pieceSelectorRef}
        data-access-auto-focus='true'
        // inputRef={pieceSelectorRef}
        value={selectedPiece}
        placeholder='Select Piece'
        fullWidth
        className='piece-selector'
        data-test='piece-selector'
        onChange={(e) => handleOnChange('selectedPiece', e.target.value)}
        SelectProps={{
          MenuProps: {
            PaperProps: {
              className: 'player-piece-selector-pop-over',
              style: {
                // maxHeight: '300px',
              },
            },
          },
        }}
      >
        {playerPieceItems.filter((option) => !excludePieces.includes(option.value)).map((option) => (
          <MenuItem key={option.id} value={option.value} data-test={`piece-${option.id}`}>
            {option.text}
            <img
              className='piece-icon'
              src={option.image}
              alt='Piece'
              style={{
                marginLeft: 'auto',
                marginRight: '10px',
                width: '2em',
              }}
            />
          </MenuItem>
        ))}
      </TextField>
    </div>
  );
});

export default PlayerSetup;
